import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { EmailService } from "src/app/services/email.service";

@Component({
    selector: 'app-component-verify-email-success',
    templateUrl: './verify-email-success.component.html',
    styleUrls: ['./verify-email-success.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerifyEmailSuccessComponent implements OnInit, AfterContentChecked {
    isMobile = window.innerWidth < 1000 ? true : false;
    id: string;

    constructor(
        private router: Router,
        private emailService: EmailService,
        private titleService: Title,
        private activeRoute: ActivatedRoute,
        private cdref: ChangeDetectorRef) {
        this.titleService.setTitle("Xác nhận email từ khách hàng");
    }

    ngOnInit() {
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    goToDefaultPage() {
        this.router.navigate(["/"]);
    }

    verifyEmailSuccess() {
        this.emailService.verifyEmailSuccess(this.id).subscribe(
            res => {
                if (res.isRedirect) {
                    this.router.navigate([res.redirectUrl], { queryParams: { _id: res.id } });
                }
            },
            error => {
                console.log(error);
            }
        )
    }
}